const React = require("react");

function XIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6 18L18 6M6 6l12 12"
  }));
}

module.exports = XIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/XIcon.js
 ** module id = 654
 ** module chunks = 0
 **/